import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Button, Tooltip, message } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { stubDiagnosis } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import _ from "lodash";
import Wave from "./wave";
import DiaResult from "./diaResult";
import DefaultBottom from "./defaultBottom";
import { EQU_MODULE } from "./config";
// 图片引入
import outline from '../../../assets/img/diagnostic/outline.png';

class EquDiagnostic extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      diaType: this.props.diaType[0],
      // 配置项。注意需要深复制，以防改变数据源
      module: _.cloneDeep(EQU_MODULE),
      status: this.props.selectTarget.stubStatus,
    };
    // 计时器列表
    this.timeOutList = [];
    // 延时
    this.delay = 0;
    // 检测指针，默认指向module[0].children[0]
    this.pointer = [0, 0];
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.init(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectTarget && nextProps.selectTarget.key !== this.props.selectTarget.key) {
      this.setState(
        {
          status: nextProps.selectTarget.stubStatus,
        },
        () => {
          this.init(nextProps);
        },
      );
    }
  }

  init = (props) => {
    // 如果不是离线状态，开始检测
    if (this.state.status === "05") {
      this.setState({
        diaType: props.diaType[4],
      });
    } else {
      this.getRealDia(props);
      this.reloadWave(props);
    }
  };

  // 设置定时器
  setRandomProgress = () => {
    this.setFirstDiaType();
    // 获取所有子项
    const items = this.getChildrenDia();
    // 获取检测分段的次数 区间为所有检查项的数量
    const cnt = items.length;

    // 获取调取接口之前的最大进度 区间【60， 90】;
    const maxVal = Math.floor(Math.random() * 31) + 20;

    let curVal = 0;

    for (let i = 0; i < cnt + 1; i++) {
      // 每次计时间隔 2 - 5s
      this.delay += Math.random() * 2000 + 1000;

      // 为防止接口初始化失败，第一次额外延迟5s
      if (i === 0) {
        this.delay += 3000;
      }

      this.timeOutList.push(
        setTimeout(async () => {
          // 每个计时器的最小值 = 最大值 / 次数 * i;
          const partMinVal = Math.ceil((maxVal / cnt) * i);
          // 每个计时器的最大值 = 最大值 / 次数 * （i + 1）;
          const partMaxVal = (maxVal / cnt) * (i + 1);

          // 获取每个区间最小值 - 最大值之间的随机数
          curVal = partMinVal + Math.floor(Math.random() * (partMaxVal - partMinVal));
          // 如果是倒数第二个计时器，设置[60-90]
          // 此时已模拟检测完成,只是进度还未到100%；
          if (cnt - 1 === i) {
            curVal = maxVal;
          }

          const options = this.getWaveOption(curVal, true);

          // 如果不是最后一项打分的计时器
          if (cnt !== i) {
            // 每次检测完移动指针并且设置每一项的检测状态
            this.setPointer();

            // 设置水波图
            this.wave.setOptions(options);
          } else {
            // 先进入100%状态
            this.wave.setOptions(this.getWaveOption(100, true));
            // 延迟1-2s打分
            setTimeout(() => {
              this.diaComplete();
            }, Math.random() * 1000 + 1000);
          }
        }, this.delay),
      );
    }
  };

  // 第一项置为检测中
  setFirstDiaType = () => {
    this.state.module[0].children[0] = {
      ...this.state.module[0].children[0],
      status: "loading",
      msg: "检测中",
    };
    this.setState(
      {
        module: this.state.module,
      },
      () => {
        this.forceUpdate();
      },
    );
  };

  // 诊断完成打分
  diaComplete = () => {
    const options = this.getWaveOption(this.state.realResult.score || 0, false);
    // 设置水波图
    this.wave.setOptions(options);
  };

  // 设置水波图
  getWaveOption = (val, loading) => {
    let options = {
      value: val / 100,
      unit: loading ? "%" : "",
      color: "#7CE461",
      borderColor: "#1DBF41",
      bgColor: "rgba(62, 233, 126, 0.06)",
    };

    if (!loading) {
      if (val < 60) {
        options = {
          ...options,
          color: "#DF564C",
          borderColor: "#EE7E5F",
          bgColor: "rgba(224, 74, 74, 0.06)",
        };
      }
      if (val >= 60 && val < 80) {
        options = {
          ...options,
          color: "#F8C34F",
          borderColor: "#ECBD41",
          bgColor: "rgba(224, 160, 74, 0.06)",
        };
      }
      if (val >= 80 && val < 100) {
        options = {
          ...options,
          color: "#65DCE4",
          borderColor: "#50BDDB",
          bgColor: "rgba(74, 190, 224, 0.06)",
        };
      }

      if (val === 100) {
        // 如果是100分，
        this.setState({
          diaType: this.props.diaType[2],
        });
      } else {
        this.setState({
          diaType: this.props.diaType[3],
        });
      }
    }
    return options;
  };

  // 取消检测
  cancelDia = () => {
    // 清除计时器
    for (let i = 0; i < this.timeOutList.length; i++) {
      clearTimeout(this.timeOutList[i]);
    }
    // 设置页面状态为检测检测中断
    this.setState({
      diaType: this.props.diaType[1],
    });
  };

  // 重新检测
  reloadWave = async (props) => {
    props = props || this.props;
    // 设置页面状态为检测中
    this.setState({
      diaType: props.diaType[0],
    });
    // 清空计时器数组
    this.timeOutList = [];
    this.delay = 0;
    // 指针置0
    this.pointer = [0, 0];
    // 重置数据源
    // 数据源重置后 DiaResult会自动收集错误信息
    await this.setState({
      module: _.cloneDeep(EQU_MODULE),
    });
    // 设置水球值为0；
    this.wave.setOptions(this.getWaveOption(0, true));
    // 重新设置计时器
    this.setRandomProgress();
  };

  // 获取诊断状态
  getDiaType = (type) => {
    return this.diaType[type];
  };

  // 真实检测接口
  getRealDia = (props) => {
    fetchHandler(stubDiagnosis, { stubId: props.selectTarget.key }).then((res) => {
      if (res && res.code === "success") {
        this.setState({
          realResult: res.data,
        });
      }
    });
  };

  // 获取所有子项
  getChildrenDia = () => {
    const { module } = this.state;
    let result = [];
    module.map((v) => {
      result = [...result, ...v.children];
      return true;
    });

    return result;
  };

  // 移动指针
  setPointer = () => {
    /** 不建议像下面这样使用module. 因setState可能是异步的&它的合并机制，直接对变量module操作会导致module值无法得到预期
     * 需要直接操作this.state.module
    let { module } = this.state;
  */

    // 如果没有拿到真实的检测数据，直接结束检测
    if (!this.state.realResult || !this.state.realResult.resultData) {
      message.error("检测失败，请重新检测!");
      this.cancelDia();
      return;
    }

    const x = this.pointer[0];
    const y = this.pointer[1];

    // 在设置指针之前将当前项匹配真实数据写入module
    this.setModuleByPointer();

    if (!this.state.module[x].children[y + 1]) {
      // 如果某一模块所有子项检查完毕，则进入下一模块
      this.pointer = [x + 1, 0];
    } else {
      // 否则继续检查此模块的下一项
      this.pointer = [x, y + 1];
    }
    // 如果指针没有溢出
    if (this.state.module[this.pointer[0]]) {
      // 将下一项状态置为loading
      this.state.module[this.pointer[0]].children[this.pointer[1]] = {
        ...this.state.module[this.pointer[0]].children[this.pointer[1]],
        status: "loading",
        msg: "正检测...",
      };

      this.setState(
        {
          module: this.state.module,
        },
        () => {
          // setState后强制渲染，否则在异步setTimeOut中react会自动合并setState，等异步执行栈结束后才会重绘
          this.forceUpdate();
        },
      );
    }
  };

  // 通过指针将接口获取的真实数据写入module
  setModuleByPointer = () => {
    const x = this.pointer[0];
    const y = this.pointer[1];

    const { resultData } = this.state.realResult;

    const key = this.state.module[x].children[y].key;

    // 目标检测模块对应的真实数据值
    const targetRealObj = resultData[key];

    let status;
    if (targetRealObj.abnormal === 1) {
      status = "error";
    } else {
      status = "success";
    }
    // check=0,跳过检查=无数据
    if (targetRealObj.check === 0) {
      status = "uncheck";
    }
    this.state.module[x].children[y] = {
      ...this.state.module[x].children[y],
      status: status,
      msg: status === "uncheck" ? "近7天无充电数据" : targetRealObj.message,
    };

    this.state.module[x] = {
      ...this.state.module[x],
      errorCnt: this.state.module[x].children.filter((v) => v.status === "error").length,
      completeCnt: this.state.module[x].children.filter((v) => v.status !== "waiting").length,
    };

    this.setState({
      module: this.state.module,
    });
  };

  // 返回
  back = () => {
    this.props.setSelectInfo({
      type: 0, // 选择的目标 0未选择 1电站 2设备
      info: null,
    });
  };

  render() {
    const { diaType } = this.state;
    const { selectTarget } = this.props;

    return (
      <div>
        <div className='back'>
          {diaType.type !== 0 && (
            <span onClick={this.back}>
              <LeftOutlined />
              <a>返回</a>
            </span>
          )}
        </div>
        <div className='task-box'>
          <div className='wave-container'>
            {this.state.status === "05" ? (
              <img
                src={outline}
                style={{ width: "100%" }}
                alt=''
              />
            ) : (
              <Wave ref={(ref) => (this.wave = ref)} />
            )}
          </div>
          <div className='text-info-container'>
            <p>{diaType.text}</p>
            {diaType.info && <p className='info'>检测结束后，可查看各项结果和参考定位问题。</p>}
            <p>
              当前诊断设备：
              <Tooltip title={selectTarget.key}>
                <span className='target-name'>{selectTarget.key}</span>
              </Tooltip>
              {diaType.type !== 0 && (
                <Button
                  type='default'
                  className='default-btn'
                  style={{ marginLeft: "10px" }}
                  onClick={this.props.onSelect}>
                  切换设备
                </Button>
              )}
            </p>
            <Button
              className='ant-btn-x'
              style={{ marginTop: "30px" }}
              type='primary'
              disabled={this.state.status === "05"}
              onClick={() => {
                if (diaType.type === 0) {
                  this.cancelDia();
                } else {
                  this.init(this.props);
                }
              }}>
              {diaType.btnText}
            </Button>
          </div>
        </div>
        {this.state.status === "05" ? (
          <DefaultBottom dataSource={this.state.module} className='equ-default-bottom' />
        ) : (
          <DiaResult
            onAdd={this.props.onAdd}
            selectTarget={this.props.selectTarget}
            dataSource={this.state.module}
            ref={(ref) => (this.diaResult = ref)}
          />
        )}
      </div>
    );
  }
}

export default EquDiagnostic;



// WEBPACK FOOTER //
// ./src/AntD/pages/diagnosticManage/diagnosticAnalysis/equDiagnostic.js